// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const SUPABASE_URL = "https://aapqmohjgrhzskmovlqf.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFhcHFtb2hqZ3JoenNrbW92bHFmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzMyNDc2MjIsImV4cCI6MjA0ODgyMzYyMn0.VdNGLtiw17wg_WO6GX4OSry5fjgM2V2agM8SCif7g-A";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);